import AppStatisticsIndex from "./statistic.vue";
import AppStatisticsList from "./list/list.vue";

const routes = [
  {
    path: "/statistic",
    component: AppStatisticsIndex,
    meta: {
      auth: {
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "statistic.index",
        component: AppStatisticsList,
        meta: {
          auth: {
            roles: "doorType.create",
            redirect: { name: "auth.login" }
          }
        }
      }
    ]
  }
];

export default routes;
